import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import domtoimage from 'dom-to-image';
import GISExpands from './../sig/selections/expands/GISExpands';
import HocGraphicsFilters from '../container/Filter&Graphics/containers/hocGraphics&Filters';
import MapView from './../container/MapContainer/MapView';
import DashTotalResults from './container/DashTotalResults';
import DashOptionContainer from './container/DashOptionContainer';
import { saveAs } from 'file-saver'
import './style.css'

//Visor del dash board, en este contenedor se define el tamaño del dashboard, y se cargan los dos lados tanto como menus y graficas

class HOC_VIEW extends Component {
  state = {
    anchoMap: false
  }

  closeMessageResult = () => {
    this.props.closeMessageResult();
  }

  handlerFromMap = (data) => {
    this.setState({ anchoMap: data })
  }

  handleDownloadInfo = () => {
    var node = document.getElementsByClassName('chartBlock')[0];
    var file = 'DatosDashboard';
    node.classList.add('background-download-gr');
    domtoimage.toBlob(node)
      .then(function (blob) {
        saveAs(blob, file + '.png');
        node.classList.remove('background-download-gr');
      });
  }

  handleCloseMenu = () => {
    this.props.CloseMenu();
  }

  render() {
    return (
      <Grid item lg={12} style={{
        overflow: 'auto',
        position: 'absolute',
        maxWidth: '98%',
        overflowY: 'inherit',
        transition: 'all .15s',
        flexDirection: 'row',
        marginLeft: this.props.expanded ? '177px' : ' 0px'

      }} className={'dashboard-hoc'}>
        <Grid container className="hoc" style={{
          height: '100%',
          width: '100%',
          flexDirection: 'row'
        }} >
          <Grid className="Filter" item xs={this.state.anchoMap ? 6 : 4} >
            {this.props.select !== 'dashboard' ?
              <GISExpands
                tipoSeleccion={this.props.select}
                filtroSeleccion={this.props.filterProps}
                CloseMenu={this.handleCloseMenu}
              ></GISExpands> :
              <MapView
                dataResult={this.props.mapResult}
                fromMap={this.handlerFromMap}
                sendPolygon={this.props.sendPolygon}
              ></MapView>
            }
          </Grid>
          <Grid className="Results" xs={this.state.anchoMap ? 6 : 8} item>
            <DashOptionContainer DownloadInfo={this.handleDownloadInfo} />
            <DashTotalResults timeResult={this.props.donaJornadaResult} />
            <HocGraphicsFilters
              topcomuna={this.props.topcomuna}
              totales={this.props.totales}
              donas={this.props.donas}
              lineas={this.props.lineas}
              matrices={this.props.matrices}
              tops={this.props.tops}
              timeHorasResult={this.props.timeHorasResult}
              timeEdadResult={this.props.timeEdadResult}
              partediarioResult={this.props.partediarioResult}
              guagesResult={this.props.guagesResult}
              sicResult={this.props.sicResult}
              caracterizacionResult={this.props.caracterizacionResult}
              cnpResult={this.props.cnpResult}
              rumbaSeguraResult={this.props.rumbaSeguraResult}
              firstLoad={this.props.firstLoad}
              openDialog={this.props.openDialog}
              anchoMap={this.state.anchoMap}
            />
          </Grid>
        </Grid>

      </Grid>
    );
  }
}

export default HOC_VIEW;
